import * as Sentry from '@sentry/angular-ivy';
import { ErrorHandler } from '@angular/core';
import { environment } from '../environments/environment';

Sentry.init({ dsn: environment.RAVEN_CONFIG, release: environment.version });

export class SentryErrorHandler implements ErrorHandler {
  handleError(err: any) {
    if (!environment.local) {
      const error = err.error || err.message || err.originalError || err;
      const exception = String(error).toLowerCase();
      if (
        !error ||
        exception.includes('object not found matching id') ||
        exception.includes('non-error exception captured with keys') ||
        exception.includes('0 unknown error') ||
        exception.includes('unauthorized')
      ) {
        console.log('Error avoided: ', err);
        return;
      }
      Sentry.captureException(error);
      console.error('Sentry err: ', err);
    } else {
      console.log('Local error: ', err);
    }
  }
}
